import Flex from 'components/Flex'
import styled from 'styled-components'
import { COLORS } from 'theme'
import { FONT } from 'theme/font'

import { Tabs } from 'antd'

export const StyledTabs = styled(Tabs)`
  font-style: normal;
  font-weight: ${FONT.FW_500};
  font-size: ${FONT.F_SM};
  line-height: 21px;
  .ant-tabs-nav-list {
    border-right: ${props =>
      props.border ? `1px solid ${COLORS.GREY_T_90}` : 'none'};
  }
  .ant-tabs-nav {
    width: 100% !important;
  }
  .ant-tabs-tab {
    margin-top: 0 !important;
    color: ${COLORS.GREY_T_60};
    background: ${COLORS.GREY_T_98} !important;
    border-radius: 0 !important;
    border-bottom: 1px solid ${COLORS.GREY_T_90} !important;
  }
  .ant-tabs-tab-active {
    background: ${COLORS.WHITE} !important;
  }
  .ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn {
    color: ${props => (props.textColor ? props.textColor : COLORS.GREY_T_30)};
  }
`

export const SectionWrapper = styled(Flex)`
  width: 100%;
  height: calc(100vh - 142px);
  overflow: scroll;
  background: ${COLORS.WHITE};
  &::-webkit-scrollbar {
    // display: '';
  }
`
export const PaddedDiv = styled(Flex)`
  padding: 20px 25px;
  gap: 25px;
`
export const TopHeader = styled(Flex)`
  position: relative;
  width: 100%;
  font-size: ${FONT.F_3XL};
`
export const TopHeading = styled(Flex)`
  font-style: normal;
  font-weight: ${FONT.FW_700};
  font-size: ${FONT.F_XL};
  line-height: 28px;
  color: ${COLORS.GREY_P_100};
`
export const MainWrapper = styled.div`
  padding-right: 15%;
  ${props => props?.marginBottom && `margin-bottom: ${props?.marginBottom}`}
`
